import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-screen-2xl mx-auto">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="text-xl md:text-2xl font-bold font-heading text-primary-500 whitespace-nowrap">
              非麻瓜漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>

            <div
              className="relative"
              onMouseEnter={() => setCategoryOpen(true)}
              onMouseLeave={() => setCategoryOpen(false)}
            >
              <button
                className={`flex items-center gap-1 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {categoryOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2">
                  <div className="bg-background-50 rounded-lg border border-background-200/70 py-2 px-1 min-w-[160px]">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-2 px-3 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 rounded transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 pb-4">
            <Link
              to="/"
              className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded transition-colors cursor-pointer"
            >
              首页
            </Link>
            <div className="px-4 py-2.5 text-sm text-foreground-600 font-medium">分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 pl-8 pr-4 py-2 text-sm text-foreground-700 hover:bg-background-100 rounded transition-colors cursor-pointer"
              >
                <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}